/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/13
 * Time: 16:28
 * Desc: 活动类型编辑
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { ElTable } from 'element-ui/types/table';
import { isConstructorDeclaration } from 'typescript';
import { IPSService } from '@/services/ipsServices';

// 子组件
import ConfigureKeywords from '@/views/components/configureKeywords/configureKeywords.vue';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import NewSelectSite from '@/views/components/newSelectSIte';

@Component({
  components: {
    ConfigureKeywords,
    NoAuth,
  },
})
export default class ActivityTypeEdit extends Vue {
  /* 数据 */

  /**
   * 活动类型详情
   * @type {ItemObject}
   */
  public activityTypeInfo: ItemObject = {};

  /**
   * 表单验证条件
   * @type {ItemObject}
   */
  public typeRuleArr: ItemObject = {
    actType: [{ required: true, message: '请输入活动类型' }],
    columns: [{ required: false, message: '请配置活动关键词' }],
    act_order_form: [{ required: false, message: '请配置报名关键词' }],
  };

  // 进行新建活动时，由于无法获取列表，为了固定左边模拟展示，所以写一个参数用来保存
  public defaultActShowColumns: ItemArray<ActTypeColumns> = [
    {
      column_title: '活动上架时间',
      column_name: 'act_begin_time',
      column_type: 'datetime',
      column_format: 'y-m-d H:i',
      column_length: '0',
      column_required: 1,
      rule_required: '',
      is_custom: 0,
    },
    {
      column_title: '活动下架时间',
      column_name: 'act_end_time',
      column_type: 'datetime',
      column_format: 'y-m-d H:i',
      column_length: '0',
      column_required: 1,
      rule_required: '',
      is_custom: 0,
    },
  ];

  /**
   * 默认配置报名项
   * @type {ItemObject}
   */
  public defaultSignUpColumn: ActTypeColumns = {
    column_title: '手机号',
    column_name: 'mobile',
    column_type: 'input',
    column_format: 'number',
    column_length: '11',
    column_required: 1,
    rule_required: '^1(3|4|5|6|7|8|9)\\d{9}$',
    is_custom: 0,
  };

  /**
   * 已选择活动项的关键词
   * @type {any[]}
   */
  public checkedActColumns: ItemArray<ActTypeColumns> = [];

  /**
   * 可选择的活动项关键词
   * @type {any[]}
   */
  public configActColumns: ItemArray<ActTypeColumns> = [];
  public oneTitle = '活动关键字';
  public twoTitle = '报名字段';

  /**
   * 可选择的报名项关键词
   * @type {any[]}
   */
  public configSignUpColumns: ItemArray<ActTypeColumns> = [];

  /**
   * 已选择的报名项关键词
   * @type {any[]}
   */
  public checkSignUpColumns: ItemArray<ActTypeColumns> = [];

  /**
   * 是否签名
   * @type {boolean}
   */
  public is_sign_up = false;

  public is_open_scroll = false;
  /**
   * 是否添加商品
   */
  public is_add_product = false;

  /**
   * 最终的网点列表
   * @type {number}
   */
  public finalSiteList: string[] = [];

  /**
   * 活动适用网点
   * @type {string}
   */
  public suitableSite = '1';


  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 列表是否全选
   * @type {boolean}
   */
  public isCheckedAll = false;

  /* 此处是点击报名后需要默认选中的列名 */
  public needArr = ['act_points', 'act_order_begin_time', 'act_order_end_time'];

  /* 方法 */

  /**
   * 获取活动类型详情
   */
  public getActTypeDetail(): void {
    if (this.$route.params.id === '0') {
      // 首次新建
      this.activityTypeInfo.is_need_order = this.is_sign_up;
      this.checkedActColumns = this.defaultActShowColumns;
      return;
    } else {
      // 列表进入
      const postParams = {
        actTypeId: Number.parseInt(this.$route.params.id),
      };
      IPSService.getActTypeDetail({ postParams }).then((res) => {
        this.activityTypeInfo = res;
        this.is_sign_up = res.is_need_order === 1;
        let flag = false;
        const resList = res.columns.map((i) => {
          return i.column_name;
        });
        if (resList.includes('act_begin_time')) {
          flag = true;
        }
        this.checkedActColumns = flag ? res.columns : res.columns.concat(this.defaultActShowColumns);
        this.checkSignUpColumns = res.act_order_form;
        this.suitableSite = `${res.isAllSites}`;
        this.is_add_product = !!res.is_need_product;
      });
    }
  }

  /**
   * 获得报名项列表
   * @return null
   */
  public getSignUpList(): void {
    const queryParams = {
      accType: 2,
      actTypeId: Number.parseInt(this.$route.params.id),
    };
    IPSService.getActTypeColumnList({ queryParams }).then((res) => {
      if (res.count > 0) {
        this.configSignUpColumns = res.list;
        this.configSignUpColumns.splice(1, 0, this.defaultSignUpColumn);
      } else {
        this.configSignUpColumns = [];
      }
    });
  }

  /**
   * 获得活动类型列表，获得活动类型时，实时判断是不是必填字段
   * @api
   */
  public getActList(): void {
    const unSignUpArr = ['act_begin_time', 'act_end_time', 'act_description'];

    const queryParams = {
      accType: 1,
      actTypeId: Number.parseInt(this.$route.params.id),
    };
    IPSService.getActTypeColumnList({ queryParams }).then((res) => {
      if (res.count > 0) {
        if (this.is_sign_up) {
          this.configActColumns = res.list;
        } else {
          // 未报名默认不展示下面的内容
          this.configActColumns = res.list.filter((item) => {
            return unSignUpArr.includes(item.column_name);
          });
        }
      } else {
        this.configActColumns = [];
      }
    });
  }

  /**
   * 是否需要报名
   * @param value
   */
  public orderRadioChange(value) {
    this.is_sign_up = value;
    // 此处用来判断右边默认必选内容
    if (value) {
      this.getActList();
      setTimeout(() => {
        // 点击报名后的选中框，需要delay函数进行延时才能选中
        this.checkedActColumns = this.checkedActColumns.concat(
          this.configActColumns.filter((item) => {
            return this.needArr.includes(item.column_name);
          }),
        );
      }, 500);
      this.getSignUpList();
      this.checkSignUpColumns.push(this.defaultSignUpColumn);
    } else {
      this.checkedActColumns = this.defaultActShowColumns;
      this.checkSignUpColumns = [];
      this.getActList();
      // this.getTypeSiteList();
    }
  }

  /**
   * 是否需要添加商品
   * @param value
   * @returns null
   */
  public addProRadioChange(value) {
    this.is_add_product = value;
  }

  /**
   * 返回列表
   * @return null
   */
  public onGoBack(): void {
    this.$router.go(-1);
  }

  /**
   * 接收子组件变更过的值
   * @param value
   * @param type
   */
  public updateCheckedColumns(value, type) {
    if (type == 'ACT') {
      this.checkedActColumns = value;
    } else if (type == 'SIGN-UP') {
      this.checkSignUpColumns = value;
    }
  }

  /**
   * api 更新活动类型
   * @param postParams
   */
  public updateActTypeDetail(postParams): void {
    IPSService.updateActTypeDetail({ postParams }).then((responseData: any) => {
      if (responseData.result) {
        this.$message.success('保存成功');
        this.$router.go(-1);
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /**
   * 新增适用网点
   * @return null
   */
  public onAddSite(): void {
    new NewSelectSite()
      .open({
        service: 'authTree',
        selectCodes: this.finalSiteList || [],
      })
      .then((res) => {
        this.finalSiteList = res;
      });
  }

  /**
   * 获取列表
   * @return null
   */
  public getLists(): void {
    this.getActList(); // 获得活动类型列表
    this.getSignUpList(); // 获得报名项列表
    this.getActTypeDetail(); // 获取活动类型详情
  }

  /**
   * 获取活动适用网点
   */
  public getTypeSiteList(): void {
    this.finalSiteList = [];
    const queryParams = {
      actTypeId: Number.parseInt(this.$route.params.id),
    };
    IPSService.getActTypeApplySites({ queryParams }).then((res) => {
      if (res.list.length > 0) {
        this.finalSiteList = res.list.map(v=>v.siteCode)
        // res.list.forEach((item) => {
        //   // 字段名称不统一需要格式化数据
        //   this.finalSiteList.push({
        //     name: item.siteName,
        //     code: item.siteCode,
        //   });
        // });
      }
    });
  }

  /**
   * 保存配置信息
   * @return null
   */
  public onSaveActivityInfo(): void {
    let tempList = [];
    // 组装数组
    if (this.finalSiteList.length > 0 && +this.suitableSite === 0) {
      tempList = this.finalSiteList;
    } else {
      this.finalSiteList = [];
    }
    if (this.checkedActColumns.length === 0) {
      this.$message.warning('请配置关键词');
      return;
    }
    // @ts-expect-error
    this.activityTypeInfo.actTypeId = Math.trunc(this.$route.params.id);
    this.activityTypeInfo.is_enable = 1;
    this.activityTypeInfo.columns = this.checkedActColumns;
    if (this.is_sign_up) {
      this.activityTypeInfo.act_order_form = this.checkSignUpColumns;
    } else {
      this.activityTypeInfo.act_order_form = [];
    }
    this.activityTypeInfo.is_need_order = this.is_sign_up ? 1 : 0;
    this.activityTypeInfo.is_need_product = this.is_add_product ? 1 : 0;
    this.activityTypeInfo.required_pic = 1;
    this.activityTypeInfo.isAllSites = Number.parseInt(this.suitableSite);
    this.activityTypeInfo.siteCodeList = tempList;
    const postParams = this.activityTypeInfo;
    (this.$refs.actTypeForm as ElForm).validate((valid) => {
      if (valid) {
        if (this.$route.params.id !== '0') {
          this.$confirm('该活动类型已存在活动数据，修改后不会影响之前的活动数据，确认保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning',
          })
            .then(() => {
              this.updateActTypeDetail(postParams);
            })
            .catch(() => {
              this.$message.info('已取消保存');
            });
        } else {
          this.updateActTypeDetail(postParams);
        }
      } else {
        this.$message.warning('请确认必填项');
      }
    });
  }

  /* 周期 */

  /**
   * 当组建加载时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-BASIC-ACTIVITY');
    if (this.isContentBodyShow) {
      // 此处先getActTypeDetail()是为了获得is_sign_up的状态，并且要设置delay函数
      this.getLists();
      setTimeout(() => {
        this.getLists();
      }, 500);
      if (+this.$route.params.id !== 0) {
        this.getTypeSiteList();
      } // 获取活动适用网点
    }
  }
}
